export default __webpack_public_path__ + "static/media/chartsV2.f295ad4e.png";